export default __webpack_public_path__ + "static/media/header.95e73c38.jpg";